// src/components/RenderVehicle.js
import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import WhatsappIcon from "./whatsAppIcon";

const RenderVehicle = ({ vehicle }) => {
  return (
    <Card sx={{ width: 345 }}>
      <CardMedia
        component="img"
        sx={{ width: "100%", height: "100%", objectFit: "contain" }}
        height="140"
        image={`${process.env.PUBLIC_URL}/${vehicle.imageUrl}`}
        alt={vehicle.name}
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {vehicle.name}
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          🚖 Body Type: {vehicle.bodyType}
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          💺 Seating Capacity: {vehicle.seatingCapacity} Seats
        </Typography>
        <Typography
          variant="body2"
          component="div"
          sx={{ color: "text.secondary" }}
        >
          🔧 Type: {vehicle.type}
        </Typography>
        <Typography variant="body1" sx={{ mt: 2, mb: 1 }}>
          Rent Price: ₹{vehicle.price} / day
        </Typography>
        <Button
          variant="contained"
          color="primary"
          href={`tel:${7015006321}`}
        >
          Call to Rent
        </Button>
        <WhatsappIcon name={vehicle.name} shortText={true} color="black" />
      </CardContent>
    </Card>
  );
};

export default RenderVehicle;
